import type { SpiffProcessStatus } from "@/api/dto/process-instance";

/**
 * UI 上の案件ステータス。SpiffArena の生ステータスと 1:1 ではない。
 *
 * - `draft`: 起票したが最初の起案フォームを未提出
 * - `returned`: 差し戻し。このモデルでは差し戻し分岐が endEvent なので
 *   生ステータスは `complete` になる（→ metadata で判別する）
 */
export type CaseStatus =
  | "draft"
  | "inProgress"
  | "returned"
  | "completed"
  | "canceled"
  | "suspended"
  | "error";

export const CASE_STATUSES: readonly CaseStatus[] = [
  "draft",
  "inProgress",
  "returned",
  "completed",
  "canceled",
  "suspended",
  "error",
];

export type CurrentStep = {
  readonly taskGuid: string | null;
  /** BPMN の要素 id（例: Activity_ManagerReview）。判定に使う */
  readonly name: string | null;
  /** 表示名（例: 部長確認）。表示専用 */
  readonly label: string | null;
  readonly waitingFor: string | null;
};

export type CaseListItem = {
  /** process instance id。API 呼び出しに使う生値 */
  readonly caseId: number;
  /** 表示用の案件番号（例: #42） */
  readonly caseNumber: string;
  /** 起票フォームの件名（metadata）。未設定なら null（モデル表示名で埋めない） */
  readonly title: string | null;
  readonly processModelId: string;
  readonly processModelDisplayName: string;
  /** 起票者。全案件モニタの「起票者」列で使う。 */
  readonly initiator: string | null;
  readonly status: CaseStatus;
  /** 導出前の生ステータス。デバッグ・詳細表示用 */
  readonly rawStatus: SpiffProcessStatus;
  readonly currentStep: CurrentStep | null;
  readonly submittedAt: Date | null;
  readonly completedAt: Date | null;
  readonly updatedAt: Date | null;
  readonly lastMilestone: string | null;
  /** 設定で宣言した process instance metadata のみ */
  readonly metadata: Readonly<Record<string, string | null>>;
};
